import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { CalendarPlanForm } from './Sections/CalendarPlanForm';
import { FundingDirectionsForm } from './Sections/FundingDirectionsForm';
import { LoanRepaymentScheduleForm } from './Sections/LoanRepaymentScheduleForm';

export const CashFlowElements: FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.CASH_FLOW_ELEMENTS,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.cashFlowElements.title')}
        />
      </FormSectionCard>

      <CalendarPlanForm disabled={!canAccess} />
      <LoanRepaymentScheduleForm disabled={!canAccess} />
      <FundingDirectionsForm disabled={!canAccess} />
    </>
  );
};
